"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Types = _interopRequireDefault(require("../types/Types"));

var _Errors = require("../errors/Errors");

var _ParcelGetMethods = _interopRequireDefault(require("./methods/ParcelGetMethods"));

var _ParcelChangeMethods = _interopRequireDefault(require("./methods/ParcelChangeMethods"));

var _ParentGetMethods = _interopRequireDefault(require("./methods/ParentGetMethods"));

var _ParentChangeMethods = _interopRequireDefault(require("./methods/ParentChangeMethods"));

var _ChildGetMethods = _interopRequireDefault(require("./methods/ChildGetMethods"));

var _IndexedChangeMethods = _interopRequireDefault(require("./methods/IndexedChangeMethods"));

var _ChildChangeMethods = _interopRequireDefault(require("./methods/ChildChangeMethods"));

var _ElementChangeMethods = _interopRequireDefault(require("./methods/ElementChangeMethods"));

var _ModifyMethods = _interopRequireDefault(require("./methods/ModifyMethods"));

var _ActionCreators = _interopRequireDefault(require("../change/ActionCreators"));

var _FilterMethods = _interopRequireDefault(require("../util/FilterMethods"));

var _ParcelId = _interopRequireDefault(require("../parcelId/ParcelId"));

var _isIndexedValue = _interopRequireDefault(require("../parcelData/isIndexedValue"));

var _isParentValue = _interopRequireDefault(require("../parcelData/isParentValue"));

var _identity = _interopRequireDefault(require("unmutable/lib/identity"));

var _overload10 = _interopRequireDefault(require("unmutable/lib/util/overload"));

var DEFAULT_CONFIG_INTERNAL = function DEFAULT_CONFIG_INTERNAL() {
  return {
    child: undefined,
    dispatchId: '',
    lastOriginId: '',
    meta: {},
    id: new _ParcelId.default(),
    parent: {
      isIndexed: false,
      isChildFirst: false,
      isChildLast: false
    },
    registry: {},
    updateChangeRequestOnDispatch: (0, _identity.default)()
  };
};

var Parcel =
/*#__PURE__*/
function () {
  function Parcel() {
    var _this = this,
        _overload,
        _overload2,
        _overload3,
        _overload4,
        _overload5,
        _overload6,
        _overload7,
        _overload8,
        _overload9;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _configInternal = arguments.length > 1 ? arguments[1] : undefined;

    (0, _classCallCheck2.default)(this, Parcel);
    (0, _defineProperty2.default)(this, "_childParcelCache", {});
    (0, _defineProperty2.default)(this, "_dispatchId", void 0);
    (0, _defineProperty2.default)(this, "_id", void 0);
    (0, _defineProperty2.default)(this, "_isChild", void 0);
    (0, _defineProperty2.default)(this, "_isElement", void 0);
    (0, _defineProperty2.default)(this, "_isIndexed", void 0);
    (0, _defineProperty2.default)(this, "_isParent", void 0);
    (0, _defineProperty2.default)(this, "_lastOriginId", void 0);
    (0, _defineProperty2.default)(this, "_methods", void 0);
    (0, _defineProperty2.default)(this, "_onHandleChange", void 0);
    (0, _defineProperty2.default)(this, "_parcelData", void 0);
    (0, _defineProperty2.default)(this, "_parent", void 0);
    (0, _defineProperty2.default)(this, "_registry", void 0);
    (0, _defineProperty2.default)(this, "_updateChangeRequestOnDispatch", void 0);
    (0, _defineProperty2.default)(this, "_log", false);
    (0, _defineProperty2.default)(this, "_logName", "");
    (0, _defineProperty2.default)(this, "_create", function (createParcelConfig) {
      var _createParcelConfig$d = createParcelConfig.dispatchId,
          dispatchId = _createParcelConfig$d === void 0 ? _this._id.id() : _createParcelConfig$d,
          handleChange = createParcelConfig.handleChange,
          _createParcelConfig$i = createParcelConfig.id,
          id = _createParcelConfig$i === void 0 ? _this._id : _createParcelConfig$i,
          _createParcelConfig$l = createParcelConfig.lastOriginId,
          lastOriginId = _createParcelConfig$l === void 0 ? _this._lastOriginId : _createParcelConfig$l,
          _createParcelConfig$p = createParcelConfig.parcelData,
          parcelData = _createParcelConfig$p === void 0 ? _this._parcelData : _createParcelConfig$p,
          _createParcelConfig$p2 = createParcelConfig.parent,
          parent = _createParcelConfig$p2 === void 0 ? _this._parent : _createParcelConfig$p2,
          _createParcelConfig$r = createParcelConfig.registry,
          registry = _createParcelConfig$r === void 0 ? _this._registry : _createParcelConfig$r,
          _createParcelConfig$u = createParcelConfig.updateChangeRequestOnDispatch,
          updateChangeRequestOnDispatch = _createParcelConfig$u === void 0 ? (0, _identity.default)() : _createParcelConfig$u;
      var child = parcelData.child,
          value = parcelData.value,
          _parcelData$meta = parcelData.meta,
          meta = _parcelData$meta === void 0 ? {} : _parcelData$meta;
      return new Parcel({
        value: value,
        handleChange: handleChange
      }, {
        child: child,
        dispatchId: dispatchId,
        lastOriginId: lastOriginId,
        meta: meta,
        id: id,
        parent: parent,
        registry: registry,
        updateChangeRequestOnDispatch: updateChangeRequestOnDispatch
      });
    });
    (0, _defineProperty2.default)(this, "_createNew", function (_ref) {
      var value = _ref.value,
          handleChange = _ref.handleChange;
      return new Parcel({
        value: value,
        handleChange: handleChange
      });
    });
    (0, _defineProperty2.default)(this, "_dispatchToParent", function (changeRequest) {
      var parcel = _this._registry[_this._dispatchId];

      if (parcel) {
        parcel.dispatch(changeRequest);
      }
    });
    (0, _defineProperty2.default)(this, "_changeAndReturn", function (changeCatcher) {
      var result;
      var _onHandleChange = _this._onHandleChange,
          _lastOriginId = _this._lastOriginId; // swap out the parcels real _onHandleChange with a spy

      _this._onHandleChange = function (parcel, changeRequest) {
        // _changeAndReturn should not alter _lastOriginId
        // as it's never triggered by a user action
        // so revert to the current parcel's _lastOriginId
        parcel._onHandleChange = _onHandleChange;
        parcel._lastOriginId = _lastOriginId;
        result = [parcel, changeRequest];
      };

      changeCatcher(_this);
      _this._onHandleChange = _onHandleChange;

      if (!result) {
        throw (0, _Errors.ChangeAndReturnNotCalledError)();
      }

      return result;
    });
    (0, _defineProperty2.default)(this, "_boundarySplit", function (_ref2) {
      var handleChange = _ref2.handleChange;
      return _this._create({
        id: _this._id.pushModifier('bs'),
        handleChange: handleChange // temporarily disabling boundary splitting
        // until a more robust solution can be found
        // dispatchId: '%',
        // registry: {
        //     '%': this
        // }

      });
    });
    (0, _defineProperty2.default)(this, "_setData", function (parcelData) {
      _this._methods.dispatch(_ActionCreators.default.setData(parcelData));
    });
    (0, _defineProperty2.default)(this, "spread", function () {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return _this._methods.spread(notFoundValue);
    });
    (0, _defineProperty2.default)(this, "spreadDOM", function () {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return _this._methods.spreadDOM(notFoundValue);
    });
    (0, _defineProperty2.default)(this, "spreadDOMCheckbox", function () {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this._methods.spreadDOMCheckbox(notFoundValue);
    });
    (0, _defineProperty2.default)(this, "get", function (key) {
      var notFoundValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return _this._methods.get(key, notFoundValue);
    });
    (0, _defineProperty2.default)(this, "getIn", function (keyPath) {
      var notFoundValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return _this._methods.getIn(keyPath, notFoundValue);
    });
    (0, _defineProperty2.default)(this, "children", function () {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_) {
        return _;
      };
      return _this._methods.children(mapper);
    });
    (0, _defineProperty2.default)(this, "toObject", function () {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_) {
        return _;
      };
      return _this._methods.toObject(mapper);
    });
    (0, _defineProperty2.default)(this, "toArray", function () {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_) {
        return _;
      };
      return _this._methods.toArray(mapper);
    });
    (0, _defineProperty2.default)(this, "metaAsParcel", function (key) {
      return _this._methods.metaAsParcel(key);
    });
    (0, _defineProperty2.default)(this, "has", function (key) {
      return _this._methods.has(key);
    });
    (0, _defineProperty2.default)(this, "size", function () {
      return _this._methods.size();
    });
    (0, _defineProperty2.default)(this, "isFirst", function () {
      return _this._methods.isFirst();
    });
    (0, _defineProperty2.default)(this, "isLast", function () {
      return _this._methods.isLast();
    });
    (0, _defineProperty2.default)(this, "log", function () {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return _this._methods.log(name);
    });
    (0, _defineProperty2.default)(this, "spy", function (sideEffect) {
      return _this._methods.spy(sideEffect);
    });
    (0, _defineProperty2.default)(this, "spyChange", function (sideEffect) {
      return _this._methods.spyChange(sideEffect);
    });
    (0, _defineProperty2.default)(this, "onChange", function (value) {
      return _this._methods.onChange(value);
    });
    (0, _defineProperty2.default)(this, "onChangeDOM", function (event) {
      return _this._methods.onChangeDOM(event);
    });
    (0, _defineProperty2.default)(this, "onChangeDOMCheckbox", function (event) {
      return _this._methods.onChangeDOMCheckbox(event);
    });
    (0, _defineProperty2.default)(this, "set", (0, _overload10.default)((_overload = {}, (0, _defineProperty2.default)(_overload, "1", function _(value) {
      return _this._methods.setSelf(value);
    }), (0, _defineProperty2.default)(_overload, "2", function _(key, value) {
      return _this._methods.set(key, value);
    }), _overload)));
    (0, _defineProperty2.default)(this, "update", (0, _overload10.default)((_overload2 = {}, (0, _defineProperty2.default)(_overload2, "1", function _(updater) {
      return _this._methods.updateSelf(updater);
    }), (0, _defineProperty2.default)(_overload2, "2", function _(key, updater) {
      return _this._methods.update(key, updater);
    }), _overload2)));
    (0, _defineProperty2.default)(this, "setIn", function (keyPath, value) {
      return _this._methods.setIn(keyPath, value);
    });
    (0, _defineProperty2.default)(this, "updateIn", function (keyPath, updater) {
      return _this._methods.updateIn(keyPath, updater);
    });
    (0, _defineProperty2.default)(this, "delete", (0, _overload10.default)((_overload3 = {}, (0, _defineProperty2.default)(_overload3, "0", function _() {
      return _this._methods.deleteSelf();
    }), (0, _defineProperty2.default)(_overload3, "1", function _(key) {
      return _this._methods.delete(key);
    }), _overload3)));
    (0, _defineProperty2.default)(this, "deleteIn", function (keyPath) {
      return _this._methods.deleteIn(keyPath);
    });
    (0, _defineProperty2.default)(this, "map", function (updater) {
      return _this._methods.map(updater);
    });
    (0, _defineProperty2.default)(this, "setMeta", function (partialMeta) {
      return _this._methods.setMeta(partialMeta);
    });
    (0, _defineProperty2.default)(this, "dispatch", function (dispatchable) {
      return _this._methods.dispatch(dispatchable);
    });
    (0, _defineProperty2.default)(this, "insertAfter", (0, _overload10.default)((_overload4 = {}, (0, _defineProperty2.default)(_overload4, "1", function _(value) {
      return _this._methods.insertAfterSelf(value);
    }), (0, _defineProperty2.default)(_overload4, "2", function _(key, value) {
      return _this._methods.insertAfter(key, value);
    }), _overload4)));
    (0, _defineProperty2.default)(this, "insertBefore", (0, _overload10.default)((_overload5 = {}, (0, _defineProperty2.default)(_overload5, "1", function _(value) {
      return _this._methods.insertBeforeSelf(value);
    }), (0, _defineProperty2.default)(_overload5, "2", function _(key, value) {
      return _this._methods.insertBefore(key, value);
    }), _overload5)));
    (0, _defineProperty2.default)(this, "move", (0, _overload10.default)((_overload6 = {}, (0, _defineProperty2.default)(_overload6, "1", function _(key) {
      return _this._methods.moveSelf(key);
    }), (0, _defineProperty2.default)(_overload6, "2", function _(keyA, keyB) {
      return _this._methods.move(keyA, keyB);
    }), _overload6)));
    (0, _defineProperty2.default)(this, "push", function () {
      var _this$_methods;

      return (_this$_methods = _this._methods).push.apply(_this$_methods, arguments);
    });
    (0, _defineProperty2.default)(this, "pop", function () {
      return _this._methods.pop();
    });
    (0, _defineProperty2.default)(this, "shift", function () {
      return _this._methods.shift();
    });
    (0, _defineProperty2.default)(this, "swap", (0, _overload10.default)((_overload7 = {}, (0, _defineProperty2.default)(_overload7, "1", function _(key) {
      return _this._methods.swapSelf(key);
    }), (0, _defineProperty2.default)(_overload7, "2", function _(keyA, keyB) {
      return _this._methods.swap(keyA, keyB);
    }), _overload7)));
    (0, _defineProperty2.default)(this, "swapNext", (0, _overload10.default)((_overload8 = {}, (0, _defineProperty2.default)(_overload8, "0", function _() {
      return _this._methods.swapNextSelf();
    }), (0, _defineProperty2.default)(_overload8, "1", function _(key) {
      return _this._methods.swapNext(key);
    }), _overload8)));
    (0, _defineProperty2.default)(this, "swapPrev", (0, _overload10.default)((_overload9 = {}, (0, _defineProperty2.default)(_overload9, "0", function _() {
      return _this._methods.swapPrevSelf();
    }), (0, _defineProperty2.default)(_overload9, "1", function _(key) {
      return _this._methods.swapPrev(key);
    }), _overload9)));
    (0, _defineProperty2.default)(this, "unshift", function () {
      var _this$_methods2;

      return (_this$_methods2 = _this._methods).unshift.apply(_this$_methods2, arguments);
    });
    (0, _defineProperty2.default)(this, "modifyDown", function (updater) {
      return _this._methods.modifyDown(updater);
    });
    (0, _defineProperty2.default)(this, "modifyUp", function (updater) {
      return _this._methods.modifyUp(updater);
    });
    (0, _defineProperty2.default)(this, "initialMeta", function (initialMeta) {
      return _this._methods.initialMeta(initialMeta);
    });
    (0, _defineProperty2.default)(this, "isChild", function () {
      return _this._isChild;
    });
    (0, _defineProperty2.default)(this, "isElement", function () {
      return _this._isElement;
    });
    (0, _defineProperty2.default)(this, "isIndexed", function () {
      return _this._isIndexed;
    });
    (0, _defineProperty2.default)(this, "isParent", function () {
      return _this._isParent;
    });
    (0, _defineProperty2.default)(this, "isTopLevel", function () {
      return !_this._isChild;
    });
    (0, _defineProperty2.default)(this, "pipe", function () {
      var _this$_methods3;

      return (_this$_methods3 = _this._methods).pipe.apply(_this$_methods3, arguments);
    });
    (0, _Types.default)("Parcel()", "config", "object")(config);
    var _handleChange = config.handleChange,
        _value = config.value;
    _handleChange && (0, _Types.default)("Parcel()", "config.handleChange", "function")(_handleChange);

    var _ref3 = _configInternal || DEFAULT_CONFIG_INTERNAL(),
        _child = _ref3.child,
        _dispatchId = _ref3.dispatchId,
        _lastOriginId2 = _ref3.lastOriginId,
        _meta = _ref3.meta,
        _id = _ref3.id,
        _parent = _ref3.parent,
        _registry = _ref3.registry,
        _updateChangeRequestOnDispatch = _ref3.updateChangeRequestOnDispatch;

    this._lastOriginId = _lastOriginId2;
    this._onHandleChange = _handleChange;
    this._updateChangeRequestOnDispatch = _updateChangeRequestOnDispatch;
    this._parcelData = {
      value: _value,
      child: _child,
      key: _id.key(),
      meta: _meta
    };
    this._dispatchId = _dispatchId;
    this._id = _id;
    this._isChild = !(_id && _id.path().length === 0);
    this._isElement = _parent.isIndexed;
    this._isIndexed = (0, _isIndexedValue.default)(_value);
    this._isParent = (0, _isParentValue.default)(_value);
    this._parent = _parent;
    this._registry = _registry;
    this._registry[_id.id()] = this; // methods

    this._methods = (0, _objectSpread2.default)({}, (0, _ParcelGetMethods.default)(this), (0, _ParcelChangeMethods.default)(this), (0, _ModifyMethods.default)(this), (0, _FilterMethods.default)("Parent", _ParentGetMethods.default)(this), (0, _FilterMethods.default)("Parent", _ParentChangeMethods.default)(this), (0, _FilterMethods.default)("Child", _ChildGetMethods.default)(this), (0, _FilterMethods.default)("Child", _ChildChangeMethods.default)(this), (0, _FilterMethods.default)("Indexed", _IndexedChangeMethods.default)(this), (0, _FilterMethods.default)("Element", _ElementChangeMethods.default)(this));
  } //
  // private
  //
  // from constructor


  (0, _createClass2.default)(Parcel, [{
    key: "data",
    //
    // getters
    //
    // $FlowFixMe - this doesn't have side effects
    get: function get() {
      return this._parcelData;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "value",
    get: function get() {
      return this._parcelData.value;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "meta",
    get: function get() {
      var _this$_parcelData$met = this._parcelData.meta,
          meta = _this$_parcelData$met === void 0 ? {} : _this$_parcelData$met;
      return (0, _objectSpread2.default)({}, meta);
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "key",
    get: function get() {
      return this._id.key();
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "id",
    get: function get() {
      return this._id.id();
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "path",
    get: function get() {
      return this._id.path();
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } //
    // public methods
    //
    // Spread methods

  }]);
  return Parcel;
}();

exports.default = Parcel;